import { memo, useEffect, useMemo, useState } from "react";
import PatientEntry from "./Controller/PatientEntry";

function App() {
  return <PatientEntry />;
}

export default memo(App);
